module.exports = __webpack_public_path__ + "img/1 (60).7bd83cb5.png";